import { AdministrableEmployerViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockAdministrableEmployers: AdministrableEmployerViewModel[] = [
  { organizationName: 'Tosca Test Organization 85814', partnerNumber: '8000096879', organizationNumber: '8806228345' },
  { organizationName: 'AVICON AB', partnerNumber: '0030023349', organizationNumber: '5566383906' },
  { organizationName: 'HÄLLS MÅLERI AB', partnerNumber: '0030000356', organizationNumber: '5564065356' },
  { organizationName: 'Företag 1', partnerNumber: '0030023342', organizationNumber: '5564065351' },
  { organizationName: 'Företag 2', partnerNumber: '0030023343', organizationNumber: '5564065352' },
  { organizationName: 'Företag 3', partnerNumber: '0030023344', organizationNumber: '5564065353' },
  { organizationName: 'Företag 4', partnerNumber: '0030023345', organizationNumber: '5564065354' },
];
